var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinesspeople1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "-3.26 -3.26 39.09 39.09",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.26,
    y: -3.26,
    width: 39.09,
    height: 39.09,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.381,18.807c0.012,0,0.021-0.002,0.032-0.002c0.015,0,0.026,0.002,0.042,0.002H21.381z M17.25,14.201 c0.012-0.003,0.02-0.015,0.032-0.018c0.724,2.62,2.598,4.579,4.501,4.622c1.734-0.08,3.863-2.004,4.572-4.609 c0.326,0.02,0.652-0.364,0.744-0.899c0.095-0.559-0.104-1.057-0.44-1.115c-0.022-0.003-0.043,0.01-0.065,0.011 c-0.099-4.311-2.145-5.83-4.725-5.896c-2.658,0.013-5.039,1.861-4.889,5.896c-0.024,0-0.049-0.016-0.073-0.011 c-0.337,0.058-0.535,0.557-0.439,1.115C16.561,13.85,16.911,14.257,17.25,14.201z M21.581,6.288h-0.327 c0.083-0.001,0.164,0.004,0.245,0.006C21.527,6.294,21.555,6.288,21.581,6.288z M6.963,21.882h-1.51l1.892-1.891 C3.115,20.405,0,22.016,0,26.288h9.271l-3.356-3.354L6.963,21.882z M25.366,19.553l-2.415,4.727l-0.381-3.074l0.596-0.488h-1.445 H20.4l0.598,0.488l-0.382,3.074l-2.413-4.727c-4.197,0.563-7.21,2.362-7.21,6.735h21.582 C32.574,21.915,29.561,20.116,25.366,19.553z M13.731,13.167c-0.137,1.88-0.939,4.076-2.091,5.253h4.453v-4.967 c0-5.194-2.747-7.166-6.134-7.166c-3.388,0-6.134,1.971-6.134,7.166v4.967h4.452c-1.114-1.139-1.906-3.232-2.081-5.07l0.043-0.003 c1.917,0,3.571-0.794,4.481-1.964C11.386,12.241,12.453,12.88,13.731,13.167z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesspeople1);
export default __webpack_public_path__ + "static/media/businesspeople1.e0ef5490a0663006ac960919aa4a3f4c.svg";
export { ForwardRef as ReactComponent };